<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-field v-model="inputForm.companyName" label="证照所属公司名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.licenseCategoryLabel" label="证照类别" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.licenseName" label="证照名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.quantity" label="数量（张）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.creditCode" label="统一社会信用代码" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.expireDate" label="到期日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.issueDate" label="发证日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.hasScanLabel" label="证照扫描件" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.custodianCompanyName" label="保管公司" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.custodianDeptName" label="保管部门" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.custodianName" label="保管人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.statusLabel" label="证照状态" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
        <p style="color: #AAA">附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
      <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-collapse-item title="专业信息" name="1">
        <van-row v-show="inputForm.licenseCategory === '1' && inputForm.licenseName === '企业法人营业执照'">
          <van-col span="24">
            <van-field v-model="inputForm.extraInfo.enterpriseName" label="企业名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.legalRepresentative" label="企业法人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.domicile" label="住所" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.registeredCapital" label="注册资本（万元）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.businessScope" label="经营范围" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.businessTerm" label="经营期限" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.establishmentDate" label="成立日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.issuingAuthority" label="发证部门" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          </van-col>
        </van-row>
        <van-row v-show="inputForm.licenseCategory === '2' && inputForm.licenseName === '商标注册证'">
          <van-col span="24">
            <van-field v-model="inputForm.extraInfo.trademarkName" label="注册商标" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.registrant" label="注册人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.approvedServiceItems" label="核定服务项目" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.registrationAddress" label="注册地址" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.validityTerm" label="有效期限" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.issuingAuthority" label="发证机关" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          </van-col>
        </van-row>

        <van-row v-show="inputForm.licenseCategory === '3'">
          <van-col span="24">
            <van-field v-model="inputForm.extraInfo.businessLicenseType" label="经营许可类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.businessLicenseLevel" label="经营许可等级" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.enterpriseType" label="企业类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.legalRepresentative" label="法定代表人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.enterpriseAddress" label="企业地址" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.postalCode" label="邮政编码" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.contactPhone" label="电话" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.approvalOperationDate" label="批准经营日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.businessLicenseNo" label="企业法人营业执照注册号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.registeredCapital" label="注册资本（万元）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          </van-col>
        </van-row>

        <van-row v-show="inputForm.licenseCategory === '1' && inputForm.licenseName === '组织机构代码证及IC卡'">
          <van-col span="24">
            <van-field v-model="inputForm.extraInfo.enterpriseName" label="机构名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.enterpriseType" label="机构类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.enterpriseAddress" label="地址" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.validityTerm" label="有效期限" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.issuingAuthority" label="颁发单位" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.businessLicenseNo" label="登记号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          </van-col>
        </van-row>

        <van-row v-show="inputForm.licenseCategory === '1' && inputForm.licenseName === '税务登记证'">
          <van-col span="24">
            <van-field v-model="inputForm.extraInfo.enterpriseName" label="纳税人名称" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.legalRepresentative" label="法定代表人(负责人)" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.enterpriseAddress" label="地址" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.businessScope" label="经营范围" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.enterpriseType" label="登记注册类型" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.approvalAuthority" label="批准设立机关" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.withholdingObligation" label="扣缴义务" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="inputForm.extraInfo.issuingAuthority" label="发证部门" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          </van-col>
        </van-row>

      </van-collapse-item>


    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "@/components/processRecord/processRecord.vue";
import TaskService from "@/api/flowable/TaskService";
import ProcessService from "@/api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
export default {
  name: "AamsLicenseRegInfo",
  data(){
    return {
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        id: '',
        licenseCategoryId: '',
        companyId: '',
        companyName: '',
        licenseCategory: '',
        licenseName: '',
        quantity: '1',
        creditCode: '',
        issueDate: '',
        expireDate: '',
        hasScan: '',
        custodianId: '',
        custodianName: '',
        custodianCompanyId: '',
        custodianCompanyName: '',
        custodianDeptId: '',
        custodianDeptName: '',
        remarks: '',
        createByName: '',
        createDate: '',
        attachIds: [],
        attachList: [],
        extraInfo: {
          approvalOperationDate: undefined,
          approvedServiceItems: undefined,
          businessLicenseLevel: undefined,
          businessLicenseNo: undefined,
          businessLicenseType: undefined,
          businessScope: undefined,
          businessTerm: undefined,
          contactPhone: undefined,
          domicile: undefined,
          enterpriseAddress: undefined,
          enterpriseName: undefined,
          enterpriseType: undefined,
          establishmentDate: undefined,
          issuingAuthority: undefined,
          legalRepresentative: undefined,
          licenseRegInfoId: undefined,
          postalCode: undefined,
          registeredCapital: undefined,
          registrant: undefined,
          registrationAddress: undefined,
          trademarkName: undefined,
          validityTerm: undefined,
          approvalAuthority: undefined,
          withholdingObligation: undefined
        },
        isDoTask: false,
        isLastTask: false,
      },
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
        this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/license/reg/aamsLicenseRegInfo/queryById').then(({ data }) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0,10)
        this.getDict([
          ['aams_license_category', 'licenseCategory'],
          ['aams_license_has_scan', 'hasScan'],
          ['aams_license_status', 'status']
        ])
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts) {
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/license/reg/aamsLicenseRegInfo/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
          }
          _this.$flow.startFlow(form, '/license/reg/aamsLicenseRegInfo/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
  }
}
</script>

<style scoped>

</style>
